import React, { createContext, useContext, ReactNode } from 'react';
import Player from '../lib/Player.ts';
import PlayerState from '../lib/PlayerState.ts';

interface PlayerContextType {
    player: Player | null;
    playerState: PlayerState;
}

const PlayerContext = createContext<PlayerContextType | null>(null);

// Custom hook for accessing player instance
export const usePlayer = () => {
    const context = useContext(PlayerContext);
    if (!context) {
        throw new Error('usePlayer must be used within PlayerProvider');
    }
    return context.player;
};

// Custom hook for accessing player state
export const usePlayerState = () => {
    const context = useContext(PlayerContext);
    if (!context) {
        throw new Error('usePlayerState must be used within PlayerProvider');
    }
    return context.playerState;
};

// Provider component
export const PlayerProvider: React.FC<{
    player: Player | null,
    playerState: PlayerState,
    children: ReactNode
}> = ({ player, playerState, children }) => {
    return (
        <PlayerContext.Provider value={{ player, playerState }}>
            {children}
        </PlayerContext.Provider>
    );
};
